import React from 'react';
import {BrowserRouter} from "react-router-dom"

import ScrollToTop from "./util/ScrollToTop";
import ErrorBoundary from "./util/ErrorBoundary";
import Layout from "./components/Layout";

import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import huLocale from "date-fns/locale/hu";

function App() {
    return (
        <BrowserRouter>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={huLocale}>
                <ScrollToTop>
                    <ErrorBoundary>
                        <Layout/>
                    </ErrorBoundary>
                </ScrollToTop>
            </MuiPickersUtilsProvider>
        </BrowserRouter>
    );
}

export default App;
